.ux-w-quick-order {
    display: block;

    .ux-w-wrapper__body {
        overflow: visible;

        > div:not(.ux-spinner) {
            width: 100%;
        }
    }

    &__form {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        padding: 20px 30px 60px;
    }

    &__text {
        width: 100%;
        max-width: 440px;
        margin: 0 30px;
    }

    &__number {
        width: 140px;
        padding-top: 34px;
        margin: 0 30px;
    }

    &__button {
        position: absolute;
        bottom: 30px;
        right: 30px;
    }

    &--small &,
    &--medium & {
        &__text {
            margin: 0;
        }

        &__number {
            position: absolute;
            left: 30px;
            bottom: 30px;
            margin: 0;
        }
    }

    &--medium & {
        &__number {
            bottom: 31px;
        }
    }
}
